/*!
 * CustomEase 3.2.6
 * https://greensock.com
 *
 * @license Copyright 2020, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
 */

!(function (e,t) {
    'object' === typeof exports && 'undefined' !== typeof module ? t(exports) : 'function' === typeof define && define.amd ? define(['exports'],t) : t((e = e || self).window = e.window || {});
})(this,function (e) {
    'use strict';function m(e) {
        return Math.round(1e5 * e) / 1e5 || 0;
    } var b = /[achlmqstvz]|(-?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi; var w = /[\+\-]?\d*\.?\d+e[\+\-]?\d+/gi; var Y = Math.PI / 180; var k = Math.sin; var B = Math.cos; var F = Math.abs; var J = Math.sqrt;function arcToSegment(e,t,n,s,a,r,i,o,h) {
        if (e !== o || t !== h) {
            n = F(n),s = F(s);var u = a % 360 * Y; var f = B(u); var c = k(u); var l = Math.PI; var g = 2 * l; var d = (e - o) / 2; var m = (t - h) / 2; var x = f * d + c * m; var p = -c * d + f * m; var y = x * x; var M = p * p; var v = y / (n * n) + M / (s * s);1 < v && (n = J(v) * n,s = J(v) * s);var C = n * n; var E = s * s; var b = (C * E - C * M - E * y) / (C * M + E * y);b < 0 && (b = 0);var w = (r === i ? -1 : 1) * J(b); var P = n * p / s * w; var S = -s * x / n * w; var N = f * P - c * S + (e + o) / 2; var D = c * P + f * S + (t + h) / 2; var T = (x - P) / n; var V = (p - S) / s; var _ = (-x - P) / n; var q = (-p - S) / s; var A = T * T + V * V; var R = (V < 0 ? -1 : 1) * Math.acos(T / J(A)); var G = (T * q - V * _ < 0 ? -1 : 1) * Math.acos((T * _ + V * q) / J(A * (_ * _ + q * q)));isNaN(G) && (G = l),!i && 0 < G ? G -= g : i && G < 0 && (G += g),R %= g,G %= g;var L; var O = Math.ceil(F(G) / (g / 4)); var j = []; var z = G / O; var I = 4 / 3 * k(z / 2) / (1 + B(z / 2)); var H = f * n; var Q = c * n; var Z = c * -s; var U = f * s;for (L = 0;L < O;L++) {
                x = B(a = R + L * z),p = k(a),T = B(a += z),V = k(a),j.push(x - I * p,p + I * x,T + I * V,V - I * T,T,V);
            } for (L = 0;L < j.length;L += 2) {
                x = j[L],p = j[L + 1],j[L] = x * H + p * Z + N,j[L + 1] = x * Q + p * U + D;
            }

            return j[L - 2] = o,j[L - 1] = h,j;
        }
    } function stringToRawPath(e) {
        function db(e,t,n,s) {
            f = (n - e) / 3,c = (s - t) / 3,o.push(e + f,t + c,n - f,s - c,n,s);
        } var t; var n; var s; var a; var r; var i; var o; var h; var u; var f; var c; var l; var g; var d; var m; var x = (e + '').replace(w,function (e) {
            var t = +e;

            return t < 1e-4 && -1e-4 < t ? 0 : t;
        }).match(b) || []; var p = []; var y = 0; var M = 0; var v = x.length; var C = 0; var E = 'ERROR: malformed path: ' + e;if (!e || !isNaN(x[0]) || isNaN(x[1])) {
            return console.log(E),p;
        } for (t = 0;t < v;t++) {
            if (g = r,isNaN(x[t]) ? i = (r = x[t].toUpperCase()) !== x[t] : t--,s = +x[t + 1],a = +x[t + 2],i && (s += y,a += M),t || (h = s,u = a),'M' === r) {
                o && (o.length < 8 ? --p.length : C += o.length),y = h = s,M = u = a,o = [s,a],p.push(o),t += 2,r = 'L';
            } else if ('C' === r) {
                i || (y = M = 0),(o = o || [0,0]).push(s,a,y + 1 * x[t + 3],M + 1 * x[t + 4],y += 1 * x[t + 5],M += 1 * x[t + 6]),t += 6;
            } else if ('S' === r) {
                f = y,c = M,'C' !== g && 'S' !== g || (f += y - o[o.length - 4],c += M - o[o.length - 3]),i || (y = M = 0),o.push(f,c,s,a,y += 1 * x[t + 3],M += 1 * x[t + 4]),t += 4;
            } else if ('Q' === r) {
                f = y + 2 / 3 * (s - y),c = M + 2 / 3 * (a - M),i || (y = M = 0),y += 1 * x[t + 3],M += 1 * x[t + 4],o.push(f,c,y + 2 / 3 * (s - y),M + 2 / 3 * (a - M),y,M),t += 4;
            } else if ('T' === r) {
                f = y - o[o.length - 4],c = M - o[o.length - 3],o.push(y + f,M + c,s + 2 / 3 * (y + 1.5 * f - s),a + 2 / 3 * (M + 1.5 * c - a),y = s,M = a),t += 2;
            } else if ('H' === r) {
                db(y,M,y = s,M),t += 1;
            } else if ('V' === r) {
                db(y,M,y,M = s + (i ? M - y : 0)),t += 1;
            } else if ('L' === r || 'Z' === r) {
                'Z' === r && (s = h,a = u,o.closed = !0),('L' === r || .5 < F(y - s) || .5 < F(M - a)) && (db(y,M,s,a),'L' === r && (t += 2)),y = s,M = a;
            } else if ('A' === r) {
                if (d = x[t + 4],m = x[t + 5],f = x[t + 6],c = x[t + 7],n = 7,1 < d.length && (d.length < 3 ? (c = f,f = m,n--) : (c = m,f = d.substr(2),n -= 2),m = d.charAt(1),d = d.charAt(0)),l = arcToSegment(y,M,+x[t + 1],+x[t + 2],+x[t + 3],+d,+m,(i ? y : 0) + 1 * f,(i ? M : 0) + 1 * c),t += n,l) {
                    for (n = 0;n < l.length;n++) {
                        o.push(l[n]);
                    }
                }y = o[o.length - 2],M = o[o.length - 1];
            } else {
                console.log(E);
            }
        }

        return (t = o.length) < 6 ? (p.pop(),t = 0) : o[0] === o[t - 2] && o[1] === o[t - 1] && (o.closed = !0),p.totalPoints = C + t,p;
    } function p() {
        return M || 'undefined' !== typeof window && (M = window.gsap) && M.registerPlugin && M;
    } function q() {
        (M = p()) ? (M.registerEase('_CE',n.create),a = 1) : console.warn('Please gsap.registerPlugin(CustomEase)');
    } function s(e) {
        return ~~(1e3 * e + (e < 0 ? -.5 : .5)) / 1e3;
    } function x(e,t,n,s,a,r,i,o,h,u,f) {
        var c; var l = (e + n) / 2; var g = (t + s) / 2; var d = (n + a) / 2; var m = (s + r) / 2; var p = (a + i) / 2; var y = (r + o) / 2; var M = (l + d) / 2; var v = (g + m) / 2; var C = (d + p) / 2; var E = (m + y) / 2; var b = (M + C) / 2; var w = (v + E) / 2; var P = i - e; var S = o - t; var N = Math.abs((n - i) * S - (s - o) * P); var D = Math.abs((a - i) * S - (r - o) * P);

        return u || (u = [{x:e,y:t},{x:i,y:o}],f = 1),u.splice(f || u.length - 1,0,{x:b,y:w}),h * (P * P + S * S) < (N + D) * (N + D) && (c = u.length,x(e,t,l,g,M,v,b,w,h,u,f),x(b,w,C,E,p,y,i,o,h,u,f + 1 + (u.length - c))),u;
    } var M; var a; var t; var y = /[-+=\.]*\d+[\.e\-\+]*\d*[e\-\+]*\d*/gi; var v = /[cLlsSaAhHvVtTqQ]/g; var n = ((t = CustomEase.prototype).setData = function setData(e,t) {
        t = t || {};var n; var s; var a; var r; var i; var o; var h; var u; var f; var c = (e = e || '0,0,1,1').match(y); var l = 1; var g = []; var d = []; var m = t.precision || 1; var p = m <= 1;if (this.data = e,(v.test(e) || ~e.indexOf('M') && e.indexOf('C') < 0) && (c = stringToRawPath(e)[0]),4 === (n = c.length)) {
            c.unshift(0,0),c.push(1,1),n = 8;
        } else if ((n - 2) % 6) {
            throw 'Invalid CustomEase';
        } for (0 == +c[0] && 1 == +c[n - 2] || (function _normalize(e,t,n) {
            n || 0 === n || (n = Math.max(+e[e.length - 1],+e[1]));var s; var a = -1 * e[0]; var r = -n; var i = e.length; var o = 1 / (+e[i - 2] + a); var h = -t || (Math.abs(e[i - 1] - e[1]) < .01 * (e[i - 2] - e[0]) ? (function _findMinimum(e) {
                var t; var n = e.length; var s = 1e20;for (t = 1;t < n;t += 6) {
                    +e[t] < s && (s = +e[t]);
                }

                return s;
            })(e) + r : +e[i - 1] + r);for (h = h ? 1 / h : -o,s = 0;s < i;s += 2) {
                e[s] = (+e[s] + a) * o,e[s + 1] = (+e[s + 1] + r) * h;
            }
        })(c,t.height,t.originY),this.segment = c,r = 2;r < n;r += 6) {
            s = {x:+c[r - 2],y:+c[r - 1]},a = {x:+c[r + 4],y:+c[r + 5]},g.push(s,a),x(s.x,s.y,+c[r],+c[r + 1],+c[r + 2],+c[r + 3],a.x,a.y,1 / (2e5 * m),g,g.length - 1);
        } for (n = g.length,r = 0;r < n;r++) {
            h = g[r],u = g[r - 1] || h,h.x > u.x || u.y !== h.y && u.x === h.x || h === u ? (u.cx = h.x - u.x,u.cy = h.y - u.y,u.n = h,u.nx = h.x,p && 1 < r && 2 < Math.abs(u.cy / u.cx - g[r - 2].cy / g[r - 2].cx) && (p = 0),u.cx < l && (u.cx ? l = u.cx : (u.cx = .001,r === n - 1 && (u.x -= .001,l = Math.min(l,.001),p = 0)))) : (g.splice(r--,1),n--);
        } if (i = 1 / (n = 1 / l + 1 | 0),h = g[o = 0],p) {
            for (r = 0;r < n;r++) {
                f = r * i,h.nx < f && (h = g[++o]),s = h.y + (f - h.x) / h.cx * h.cy,d[r] = {x:f,cx:i,y:s,cy:0,nx:9},r && (d[r - 1].cy = s - d[r - 1].y);
            }d[n - 1].cy = g[g.length - 1].y - s;
        } else {
            for (r = 0;r < n;r++) {
                h.nx < r * i && (h = g[++o]),d[r] = h;
            }o < g.length - 1 && (d[r - 1] = g[g.length - 2]);
        }

        return this.ease = function (e) {
            var t = d[e * n | 0] || d[n - 1];

            return t.nx < e && (t = t.n),t.y + (e - t.x) / t.cx * t.cy;
        },(this.ease.custom = this).id && M.registerEase(this.id,this.ease),this;
    },t.getSVGData = function getSVGData(e) {
        return CustomEase.getSVGData(this,e);
    },CustomEase.create = function create(e,t,n) {
        return new CustomEase(e,t,n).ease;
    },CustomEase.register = function register(e) {
        M = e,q();
    },CustomEase.get = function get(e) {
        return M.parseEase(e);
    },CustomEase.getSVGData = function getSVGData(e,t) {
        var n; var a; var r; var i; var o; var h; var u; var f; var c; var l; var g = (t = t || {}).width || 100; var d = t.height || 100; var x = t.x || 0; var p = (t.y || 0) + d; var y = M.utils.toArray(t.path)[0];if (t.invert && (d = -d,p = 0),'string' === typeof e && (e = M.parseEase(e)),e.custom && (e = e.custom),e instanceof CustomEase) {
            n = (function rawPathToString(e) {
                !(function _isNumber(e) {
                    return 'number' === typeof e;
                })(e[0]) || (e = [e]);var t; var n; var s; var a; var r = ''; var i = e.length;for (n = 0;n < i;n++) {
                    for (a = e[n],r += 'M' + m(a[0]) + ',' + m(a[1]) + ' C',t = a.length,s = 2;s < t;s++) {
                        r += m(a[s++]) + ',' + m(a[s++]) + ' ' + m(a[s++]) + ',' + m(a[s++]) + ' ' + m(a[s++]) + ',' + m(a[s]) + ' ';
                    }a.closed && (r += 'z');
                }

                return r;
            })(function transformRawPath(e,t,n,s,a,r,i) {
                for (var o,h,u,f,c,l = e.length;-1 < --l;) {
                    for (h = (o = e[l]).length,u = 0;u < h;u += 2) {
                        f = o[u],c = o[u + 1],o[u] = f * t + c * s + r,o[u + 1] = f * n + c * a + i;
                    }
                }

                return e._dirty = 1,e;
            })([e.segment],g,0,0,-d,x,p);
        } else {
            for (n = [x,p],i = 1 / (u = Math.max(5,200 * (t.precision || 1))),f = 5 / (u += 2),c = s(x + i * g),a = ((l = s(p + e(i) * -d)) - p) / (c - x),r = 2;r < u;r++) {
                o = s(x + r * i * g),h = s(p + e(r * i) * -d),(Math.abs((h - l) / (o - c) - a) > f || r === u - 1) && (n.push(c,l),a = (h - l) / (o - c)),c = o,l = h;
            }n = 'M' + n.join(',');
        }

        return y && y.setAttribute('d',n),n;
    },CustomEase);function CustomEase(e,t,n) {
        a || q(),this.id = e,this.setData(t,n);
    }p() && M.registerPlugin(n),n.version = '3.2.6',e.CustomEase = n,e.default = n;if (typeof (window) === 'undefined' || window !== e) {
        Object.defineProperty(e,'__esModule',{value:!0});
    } else {
        delete e.default;
    }
});

